import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/eln_analytics_event.py
export const ELN_ANALYTICS_ACTIONS = {
  // READ actions
  DOWNLOADED_REGISTRATION_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.ELN,
    action: 'downloaded_registration_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_REQUEST_FULFILLMENTS_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.ELN,
    action: 'downloaded_request_fulfillments_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_TRANSFER_TABLE_IN_NOTEBOOK_AS_CSV: {
    module: ANALYTICS_MODULE.ELN,
    action: 'downloaded_transfer_table_in_notebook_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_UNSTRUCTURED_OR_WELL_PLATE_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.ELN,
    action: 'downloaded_unstructured_or_well_plate_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_OUTPUT_SAMPLES_TABLE_AS_CSV: {
    module: ANALYTICS_MODULE.ELN,
    action: 'downloaded_output_samples_table_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  HOVERED_ILLEGAL_ERROR_TRIANGLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'hovered_illegal_error_triangle',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ACTIVATED_TAB: {
    module: ANALYTICS_MODULE.ELN,
    action: 'activated_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_OLD_ENTRY_VERSION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_old_entry_version',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CHANGED_TABLE_VIEW: {
    module: ANALYTICS_MODULE.ELN,
    action: 'changed_table_view',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MEASURED_NOTEBOOK_PERFORMANCE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'measured_notebook_performance',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_INSERT_CONTENT_MODAL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_ai_insert_content_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_NOTEBOOK_CHECKER: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_ai_notebook_checker',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RERAN_AI_NOTEBOOK_CHECKER: {
    module: ANALYTICS_MODULE.ELN,
    action: 'reran_ai_notebook_checker',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MARKED_AI_NOTEBOOK_CHECK_RESULT_COMPLETED: {
    module: ANALYTICS_MODULE.ELN,
    action: 'marked_ai_notebook_check_result_completed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MARKED_AI_NOTEBOOK_CHECK_RESULT_USEFUL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'marked_ai_notebook_check_result_useful',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_AI_NOTEBOOK_CHECK_FIX_SELECTED: {
    module: ANALYTICS_MODULE.ELN,
    action: 'clicked_ai_notebook_check_fix_it_for_me',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TOGGLED_ENTRY_SECTION_IN_NON_LATEST_ENTRY_VERSION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'toggled_entry_section_in_non_latest_entry_version',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_FLEXIBLE_DATA_ENTRY_MODAL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_flexible_data_entry_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_FLEXIBLE_DATA_ENTRY_POPOVER_ICON: {
    module: ANALYTICS_MODULE.ELN,
    action: 'clicked_flexible_data_entry_popover_icon',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPEN_MODAL_FROM_FLEXIBLE_DATA_ENTRY_POPOVER: {
    module: ANALYTICS_MODULE.ELN,
    action: 'open_modal_from_flexible_data_entry_popover',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_FLEXIBLE_DATA_ENTRY_REQUEST: {
    module: ANALYTICS_MODULE.ELN,
    action: 'submitted_flexible_data_entry_request',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RECEIVED_FLEXIBLE_DATA_ENTRY_EARLY_RESULT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'received_flexible_data_entry_early_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RECEIVED_FLEXIBLE_DATA_ENTRY_RESULT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'received_flexible_data_entry_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_FLEXIBLE_DATA_ENTRY_MODAL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'closed_flexible_data_entry_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  STARTED_OVER_FLEXIBLE_DATA_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'started_over_flexible_data_entry',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RETRIED_FLEXIBLE_DATA_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'retried_flexible_data_entry',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_NOTEBOOK_PERFORMANCE_MONITOR: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_notebook_performance_monitor',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_CROSS_STEP_EDITOR: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_cross_step_editor',
    actionCategory: ACTION_CATEGORY.READ,
  },

  // WRITE actions
  SENT_ENTRY_FOR_REVIEW: {
    module: ANALYTICS_MODULE.ELN,
    action: 'sent_entry_for_review',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SELF_APPROVED_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'self_approved_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ACCEPTED_ENTRY_REVIEW: {
    module: ANALYTICS_MODULE.ELN,
    action: 'accepted_entry_review',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REJECTED_ENTRY_REVIEW: {
    module: ANALYTICS_MODULE.ELN,
    action: 'rejected_entry_review',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  RETRACTED_ENTRY_REVIEW: {
    module: ANALYTICS_MODULE.ELN,
    action: 'retracted_entry_review',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REASSIGNED_REVIEW_STAGE_REVIEWER: {
    module: ANALYTICS_MODULE.ELN,
    action: 'reassigned_stage_reviewer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_REVIEW_STAGE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'completed_review_stage',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_ENTRY_FROM_TEMPLATE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_entry_from_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_REGISTRATION_TABLE_IN_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_registration_table_in_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_REGISTRATION_TABLE_CONFIG: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_registration_table_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLONED_REGISTRATION_TABLE_FROM_CONFIG: {
    module: ANALYTICS_MODULE.ELN,
    action: 'cloned_registration_table_from_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_BATCH_FROM_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'registered_batch_from_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_BIOENTITY_FROM_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'registered_bioentity_from_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_BIOENTITY_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'registered_bioentity_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TOGGLED_WATCHING_ON_REGISTRATION_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'toggled_watching_on_registration_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_PARENT_MIXTURE_INSTRUCTIONS_INTO_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'inserted_parent_mixture_instructions_into_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_STRUCTURED_TABLE_WITH_CONTAINERS: {
    module: ANALYTICS_MODULE.ELN,
    action: 'submitted_structured_table_with_containers',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * This is only used for (legacy workflows) stage entries.
   */
  CREATED_DATA_TABLE_IN_NOTEBOOK_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_data_table_in_notebook_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * This is only used for (legacy workflows) stage configurations.
   */
  CREATED_DATA_TABLE_CONFIG_IN_NOTEBOOK_TEMPLATE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_data_table_config_in_notebook_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * This is only used for (legacy workflows) stage entries.
   */
  CREATED_TRANSFER_TABLE_IN_NOTEBOOK_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_transfer_table_in_notebook_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * This is only used for (legacy workflows) stage configurations.
   */
  CREATED_TRANSFER_TABLE_CONFIG_IN_NOTEBOOK_TEMPLATE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_transfer_table_config_in_notebook_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_WELL_PLATE_TABLE_IN_NOTEBOOK_ENTRY: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_well_plate_table_in_notebook_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_TRANSFER_TABLE_ROWS_FROM_SPREADSHEET_IMPORT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'added_transfer_table_rows_from_spreadsheet_import',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FILLED_NEXT_AVAILABLE_POSITIONS_FROM_TRANSFER_TABLE_IN_NOTEBOOK: {
    module: ANALYTICS_MODULE.ELN,
    action: 'filled_next_available_positions_from_transfer_table_in_notebook',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_QUICK_EDIT_MODAL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'opened_quick_edit_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_QUICK_EDIT_MODAL: {
    module: ANALYTICS_MODULE.ELN,
    action: 'saved_quick_edit_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PERFORMED_STRUCTURED_TABLE_ACTION_FUNCTION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'performed_structured_table_action_function',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PLATE_CREATED_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'plate_created_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BOX_CREATED_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'box_created_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BOX_UPDATED_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'box_updated_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'registered_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_MIXTURE_GROUP: {
    module: ANALYTICS_MODULE.ELN,
    action: 'submitted_mixture_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_REACTION_GROUP: {
    module: ANALYTICS_MODULE.ELN,
    action: 'submitted_reaction_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TRANSFERRED_SAMPLES_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'transferred_samples_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TRANSFERRED_ROW_SAMPLES_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'transferred_row_samples_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_CONTAINER_SCHEMA_FIELDS_FROM_TRANSFER_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'updated_container_schema_fields_from_transfer_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_CONTAINERS_OR_WELLS_FROM_INVENTORY_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'updated_containers_or_wells_from_inventory_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_CONTAINERS_OR_WELLS_FROM_INVENTORY_TABLE_ROWS: {
    module: ANALYTICS_MODULE.ELN,
    action: 'updated_containers_or_wells_from_inventory_table_rows',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_CONTAINERS_TO_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'added_containers_to_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REMOVED_CONTAINERS_FROM_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'removed_containers_from_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REFRESHED_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'refreshed_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REFRESHED_STRUCTURED_TABLE_LOOKUP_COLUMNS: {
    module: ANALYTICS_MODULE.ELN,
    action: 'refreshed_structured_table_lookup_columns',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REFRESHED_NOTE_LINKED_GROUP: {
    module: ANALYTICS_MODULE.ELN,
    action: 'refreshed_note_linked_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_SAMPLES_TO_STRUCTURED_TABLE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'added_samples_to_structured_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_IMAGE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'edited_image',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  RAN_PROCESS_TASK_FINDER: {
    module: ANALYTICS_MODULE.ELN,
    action: 'ran_process_task_finder',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TOGGLED_COLUMN_LOCKING: {
    module: ANALYTICS_MODULE.ELN,
    action: 'toggled_column_locking',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TOGGLED_FILL_IN_TEMPLATE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'toggled_fill_in_template',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DUPLICATE_LOOKUP_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'duplicate_lookup_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDIT_LOOKUP_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'edit_lookup_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERT_LOOKUP_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'insert_lookup_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_CUSTOM_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'inserted_custom_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CHANGED_CUSTOM_COLUMN_TYPE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'changed_custom_column_type',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SORTED_TABLE_BY_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'sorted_table_by_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REORDERED_TABLE_DIMENSION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'reordered_table_dimension',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CONVERTED_COLUMN_TO_SINGLE_INPUT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'converted_column_to_single_input',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CONVERTED_COLUMN_FROM_SINGLE_INPUT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'converted_column_from_single_input',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATE_NOTEBOOK_LOOKUP_CONFIG: {
    module: ANALYTICS_MODULE.ELN,
    action: 'create_lookup_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETE_COLUMN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'delete_column',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERT_TEXT_BOX: {
    module: ANALYTICS_MODULE.ELN,
    action: 'insert_text_box',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETE_TEXT_BOX: {
    module: ANALYTICS_MODULE.ELN,
    action: 'delete_text_box',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REVERTED_ENTRY_VERSION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'reverted_entry_version',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_SUBTEMPLATE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'inserted_subtemplate',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MENTIONED_OBJECT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'mentioned_object',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Table Mapping
  UPDATED_TABLE_MAPPINGS: {
    module: ANALYTICS_MODULE.ELN,
    action: 'updated_table_mappings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PERFORMED_TABLE_MAPPING: {
    module: ANALYTICS_MODULE.ELN,
    action: 'performed_table_mapping',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ROW_BASED_TABLE_SUBMISSION: {
    module: ANALYTICS_MODULE.ELN,
    action: 'row_based_table_submission',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // AI features
  INSERTED_AI_GENERATED_CONTENT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'inserted_ai_generated_content',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ACCEPTED_FLEXIBLE_DATA_ENTRY_RESULT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'accepted_flexible_data_entry_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // Plate designs
  CREATED_PLATE_DESIGN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_plate_design',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PLATE_DESIGN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'updated_plate_design',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PASTED_PLATE_DESIGN: {
    module: ANALYTICS_MODULE.ELN,
    action: 'pasted_plate_design',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Copy-paste analytics
  PASTED_NOTEBOOK_ITEM: {
    module: ANALYTICS_MODULE.ELN,
    action: 'pasted_notebook_item',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BLOCKED_PASTE_NOTEBOOK_ITEM: {
    module: ANALYTICS_MODULE.ELN,
    action: 'blocked_paste_notebook_item',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_CROSS_STEP_REFERENCE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'created_cross_step_reference',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_CROSS_STEP_REFERENCE: {
    module: ANALYTICS_MODULE.ELN,
    action: 'deleted_cross_step_reference',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Keyboard shortcut analytics
  USED_KEYBOARD_SHORTCUT: {
    module: ANALYTICS_MODULE.ELN,
    action: 'used_keyboard_shortcut',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
